export enum STATUS {
	UNDEFINED,
	PENDING,
	SUCCESS,
	ERROR,
}
